"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const DebouncedSearch_1 = require("../Input/Search/DebouncedSearch");
const react_1 = __importDefault(require("react"));
const Filter = ({ column, filter, isDisabled, }) => {
    const columnFilterValue = column.getFilterValue();
    // support other filter types in the future
    if (filter.search) {
        return (react_1.default.createElement(DebouncedSearch_1.DebouncedSearch, { onChange: value => column.setFilterValue(value), placeholder: filter.search.placeholder, value: (columnFilterValue ?? ''), isDisabled: isDisabled, debounce: filter.search.debounce, type: filter.search.type }));
    }
    return null;
};
exports.Filter = Filter;
